import { Controller } from "@hotwired/stimulus"
import { track } from '../../hotjar'

export default class extends Controller {
  static values = {
    eventName: String,
  }

  connect() {
    track({
      eventName: this.eventNameValue,
    })
  }
}
